import { IShowDragBookingConfirmDialog } from "app/bookings/timeList/dragBookingConfirm/types";
import TablesLookupService from "external-services/tables-lookup-service/tablesLookup.service";
import { ITableItem } from "shared-types/SharedTypes";


async function getTableItem(table: ITableItem | string): Promise<ITableItem> {
  let tableItem: ITableItem;
  if (typeof table === 'string') {
    const tableItems = await TablesLookupService.getAllTablesByIds([table]);
    if (tableItems?.length) {
      tableItem = tableItems[0];
    }
  } else {
    tableItem = table;
  }

  return tableItem;
}


async function getTableItems(tables: ITableItem[] | string[]): Promise<ITableItem[]> {
  let tableItems: ITableItem[];
  if (tables.length && typeof tables[0] === 'string') {
    tableItems = await TablesLookupService.getAllTablesByIds(tables as string[]);
  } else {
    tableItems = tables as ITableItem[];
  }

  return tableItems;
}

export async function showDragBookingConfirmDialog(props: IShowDragBookingConfirmDialog) {
  const {
    dialogShowFn,
    dragBooking, swapWithBooking,
    fromTable, toTable, toTablesArray, fromTableArray,
    time, newTime, schedule,
    isError, isOverlap, layouts, tableJoinSwapError,
    allTimes, hasSwappedTableChanged, tableName,
    cancelledCb, fulfilledCb, isFloorPlanV2
  } = props;

  // normalises table items when id strings are used
  const fromTableItem = await getTableItem(fromTable);
  const toTableItem = await getTableItem(toTable);
  const toTableItems = await getTableItems(toTablesArray);
  const fromTableItems = await getTableItems(fromTableArray);

  dialogShowFn({
    controller: 'DragBookingConfirmCtrl',
    controllerAs: 'vm',
    templateUrl: 'app/bookings/timeList/dragBookingConfirm/dragBookingConfirm.html',
    // @ts-ignore
    parent: angular.element(document.body),
    focusOnOpen: true,
    clickOutsideToClose: true,
    locals: {
      isFloorPlanV2,
      toTable: toTableItem,
      toTablesArray: toTableItems,
      fromTable: fromTableItem,
      fromTableArray: fromTableItems,
      newTime,
      schedule,
      dragBooking,
      swapWithBooking,
      isError,
      isOverlap,
      layouts,
      tableJoinSwapError,
      allTimes,
      hasSwappedTableChanged,
      tableName
    },
    onRemoving: () => {
      if (cancelledCb) {
        cancelledCb();
      }
    }
  })
    .then((res) => {
      if (fulfilledCb) {
        fulfilledCb(res);
      }
    });
}
